// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_p1-0";